export const T = {
  en_GB: {
    notAvailable:
      "Asset class forecast is not available yet. It appears once the portfolios have been calculated.",
    errorLoading: "Error loading asset class forecast. Please refresh the page.",
    unavailable: "Asset Class Forecast Unavailable",
    contactAdvisor: "Please contact your advisor for assistance.",
  },
  nb_NO: {
    notAvailable:
      "Aktivaklasseprognosen er ikke tilgjengelig ennå. Den vises når porteføljene er beregnet.",
    errorLoading: "Feil ved lasting av aktivaklasseprognosen. Oppdater siden.",
    unavailable: "Aktivaklasseprognose ikke tilgjengelig",
    contactAdvisor: "Kontakt din rådgiver for hjelp.",
  },
} as const;
